export default "__VITE_ASSET__CXoXIcQf__"